let mutations = {
    provinceInfo(state, data) {
        // 更新信息
        state.provinces = data;
        let cityArrayTemp = [];
        data.map((item, index) => {
            state.provincesIdMap[item.province_id] = JSON.stringify(item.name);
            // 处理城市
            cityArrayTemp = item.city_list;
            let temp = '';
            cityArrayTemp.map((city, index) => {
                temp = `${item.province_id}${city.city_id}`;
                state.citysIdMap[temp] = JSON.stringify(city.name);
            });
        });
    },
    gradeInfo(state, data) {
        // 更新信息
        state.grades = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/provincialGrade/mutations.js